var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-resend-offline-conversions"},[_c('el-row',[_c('el-col',[_c('ResendGoogleOfflineConversions')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }